<div class="notification-popup-container" *ngIf="popups.length > 0">
    <div
        *ngFor="let popup of popups; trackBy: trackByFn"
        class="notification-popup"
        [@slideInRight]
        (click)="onPopupClick(popup.notification)">
        
        <div class="notification-popup-content">
            <!-- Icon -->
            <div class="notification-popup-icon">
                <mat-icon svgIcon="heroicons_solid:bell"></mat-icon>
            </div>

            <!-- Content -->
            <div class="notification-popup-body">
                <div class="notification-popup-title">
                    {{ popup.notification.title || 'New Notification' }}
                </div>
                <div class="notification-popup-message">
                    {{ popup.notification.description || popup.notification.subject || '' }}
                </div>
            </div>

            <!-- Close button -->
            <button
                mat-icon-button
                class="notification-popup-close"
                (click)="removePopup(popup.id); $event.stopPropagation()">
                <mat-icon svgIcon="heroicons_solid:x-mark"></mat-icon>
            </button>
        </div>
    </div>
</div>

